export enum PAYMENT_STATUS_ENUM {
  WAITING_PAYMENT = 'WAITING_PAYMENT',
  WAITING_REPASS = 'WAITING_REPASS',
  NOTPAID = 'NOTPAID',
  PAID = 'PAID',
  CANCELED = 'CANCELED',
  OVERDUE = 'OVERDUE',
  ERROR_SUBSCRIPTION = 'ERROR_SUBSCRIPTION',
}
